<template>
  <section class="section--figures">
    <b-container>
      <b-row>
        <b-col
          data-aos="fade-up"
          cols="12"
          :class="dynamicClass"
          class="d-flex flex-column"
          v-for="(figure, i) in figures"
          :key="i"
        >
          <div class="figure__img" :style="bgStyle(figure)"></div>
          <div class="figure d-flex flex-column justify-content-between">
            <div class="figure__content">
              <h5 v-html="figure.title"></h5>
              <p class="text--small" v-html="figure.description || figure.navigation_content"></p>
            </div>
            <div class="figure__button">
              <span class="figure__line"></span>
              <router-link
                v-if="!figure.url"
                :to="routeName(figure)"
                tag="button"
                class="btn btn-primary button--matched"
                v-scroll-to="'#scrollToOnLoad'"
              >{{ figure.btnText || btnText }}</router-link>
              <a
                class="btn btn-primary button--matched"
                v-else
                :href="figure.url"
              >{{ figure.btnText || btnText }}</a>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>

export default {
  props: ['figures', 'btnText', 'isStatic', 'itemColSize'],
  data() {
    return {
      articlesOnPage: this.figures.length,
    };
  },
  computed: {
    dynamicClass() {
      return [`col-sm-${this.itemColSize}`, { 'figure--small': this.itemColSize < 4 }];
    },
  },
  methods: {
    bgStyle(figure) {
      if (this.isStatic) {
        return { backgroundImage: `url(static/assets/${figure.imgName})` };
      }
      return figure.navigation_photo ?
        { backgroundImage: `url(${process.env.SERVER_URL}/${figure.navigation_photo})` } :
        { backgroundImage: `url(${process.env.SERVER_URL}/${figure.photo})` };
    },
    routeName(figure) {
      return this.isStatic ? { path: figure.routeName } : { path: `/need_to_know/${figure.id}` };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/helpers/_variables.scss";
@import "../styles/helpers/_include-media.scss";

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.section {
  &--figures {
    padding-bottom: 70px;
    @include media("<lg") {
      padding-bottom: 20px;
    }
  }
}

.figure {
  flex: 1;
  margin-bottom: 30px;
  background-color: $color--white-1;

  &__img {
    height: 300px;
    background-size: cover;
    background-position: center;
    background-size: 100%;
    transition: all ease 0.7s;
    background-repeat: no-repeat;
    &:hover {
      background-size: 110%;
    }
    @include media("<xl") {
      height: 250px;
    }
    @include media("<lg") {
      height: 130px;
    }
    @include media("<sm") {
      height: 230px;
    }
  }
  &__content {
    padding: 20px 22px 15px;
    min-height: 100px;
    @include media("<lg") {
      padding: 10px 0;
      min-height: 100px;
    }
  }
  &__line {
    background-color: $color--gray;
    height: 2px;
    width: 100%;
    display: block;
    @include media("<md") {
      height: 2px;
    }
  }
}
.button {
  &--matched {
    width: calc(100% - 46px);
    margin: 22px;
    border-radius: 35px;
    @include media("<lg") {
      width: 100%;
      margin: 15px 0 15px;
    }
    @include media("<sm") {
      margin: 20px 22px 20px;
      width: calc(100% - 46px);
    }
  }
}
.figure--small {
  .figure {
    &__img {
      height: 240px;
      @include media("<lg") {
        height: 130px;
      }
      @include media("<md") {
        height: 100px;
      }
      @include media("<sm") {
        height: 240px;
      }
    }
    &__content {
      padding: 30px 22px;
      min-height: 100px;
      @include media("<lg") {
        padding: 20px 10px;
        min-height: 50px;
      }
    }
    &__title {
      font-size: 24px;
      @include media("<lg") {
        font-size: 16px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Figures.vue